import i18n, { type TFunction } from 'i18next'
import type { EnhancedManCodeId } from '#api/enhancements/enhancedTmsApiTypes'

// TMS-X6M1UJ7B
const pattern = /^TMS-[1-9A-Z]{8}$/

export function isManCodeId(manCodeId: string | undefined | null): manCodeId is EnhancedManCodeId {
  if (!manCodeId) {
    return false
  }

  return pattern.test(manCodeId)
}

export function validateManCodeId(manCodeId: string | undefined | null, tFunc?: TFunction, options?: { required: boolean }): string | false {
  const t = tFunc ?? i18n.t

  if (!manCodeId) {
    if (options?.required === true) {
      return t('form.validation.required', { ns: 'shared', defaultValue: 'This field is required' })
    }
    return false
  }

  if (!pattern.test(manCodeId)) {
    return t('form.validation.invalidManCodeIdFormat', {
      ns: 'shared',
      defaultValue: 'Invalid format. The code starts with TMS- followed by 8 numbers or uppercase letters',
    })
  }

  return false
}
